import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapService } from '../_services/map/map.service';
import { GridElementRoot } from '../_models/grid-element-root';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { TopologyList } from '../_models/topology-list';
import { GPlanService } from '../_services/gplan-service/gplan.service';
import { GPlanInput } from '../_models/gplan-input';
import { GuiService } from '../_services/gui-service/gui.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SCCInput } from '../_models/scc-input';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, max } from 'rxjs/operators';
import { ModalService } from '../_services/modal/modal.service';
import { ShortCircuitCurrentAnalysisService } from '../_services/short-circuit-current-analysis-service/short-circuit-current-analysis.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-short-circuit-current-analysis',
  templateUrl: './short-circuit-current-analysis.component.html',
  styleUrls: ['./short-circuit-current-analysis.component.css']
})
export class ShortCircuitCurrentAnalysisComponent implements OnInit {

  public rootNodeVoltage: number;
  public rootNodeGridElementId: number; // will be needed when I'll perform post request
  private topology: any;
  private listOfScenariosString: Array<string> = new Array<string>();

  public listOfTopologies: Array<TopologyList> = new Array<TopologyList>();

  public mapOfScenarios: Map<string, number> = new Map<string, number>();


  public editPlanningScenarioMode: boolean;
  public selectedScenarioId: number;
  public errorResponse: boolean;
  public isScccRunning: boolean = false;

  public failureHeadingLabel: string = "";
  public successHeadingLabel: string = "";
  public failureTextLabel: string = "";
  public successTextLabel: string = "";

  public coefficientChecker: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private mapService: MapService,
    private gplanServise: GPlanService,
    private guiService: GuiService,
    private httpClient: HttpClient,
    private modalService: ModalService,
    private shortCircuitCurrentAnalysisService: ShortCircuitCurrentAnalysisService,
    private translateService: TranslateService
  ) {

    const language = localStorage.getItem("Language");
    translateService.getTranslation(language).subscribe((translations) => {
      this.failureHeadingLabel = translations["short-circuit-current-calculations"]["0be1ff45-41cb-4454-8993-a7f3806834d6"];
      this.failureTextLabel = translations["short-circuit-current-calculations"]["67e3e1fb-0cb0-4d24-a411-c0fb3d17dbfb"];
      this.successHeadingLabel = translations["short-circuit-current-calculations"]["65889168-e4b0-44d5-8171-1c9db269f827"];
      this.successTextLabel = translations["short-circuit-current-calculations"]["5c52b32f-2092-437d-b099-48a574a4a352"]
    })
  }

  ngOnInit() {
    this.getRootNodeVoltage();
    // this.getAvailableTopologies();
    // this.getAvailableScenarios();
  }


  getRootNodeVoltage(){
    this.topology = JSON.parse(localStorage.getItem("currentTopology"));
    this.mapService.getRootNode(this.topology.topologyId).subscribe((gridElementRoot: GridElementRoot) => {
      this.rootNodeVoltage = gridElementRoot.voltageAtRoot
      // return gridElementRoot.voltageAtRoot;
    });
  }

  getAvailableTopologies(){
    this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
      // this.listOfTopologies.push(response.topologiesWithRoots);
      response.topologiesWithRoots.forEach(topologyWithRoot => {
        this.listOfScenariosString.push(topologyWithRoot.internalDsoId + " - " + topologyWithRoot.TopologyId)
      })

    })
  }

  getAvailableScenarios(){
    this.gplanServise.getListAvailableScenarios().subscribe((scenarios: Array<GPlanInput>) =>{
      scenarios.forEach(element => {
        this.listOfScenariosString.push(element.name + " - " + element.id);

        this.mapOfScenarios.set(element.name, element.id);
      });
    });


    console.log("HEre is hte list pushsed topologies ... : ", this.listOfScenariosString);
    console.log("HEre is hte map of scenarios  ... : ", this.mapOfScenarios);
  }

  runSccc(){
    //------------------------------------------------------------------------
    // Need to perform POST requiest to http://hostname/icg/v1/rest/gui/runSCC
    //------------------------------------------------------------------------
    // var voltageAtRootValue = parseInt((<HTMLInputElement>document.getElementById("voltageAtRootInput")).value);
    // var topologyIdValue = JSON.parse(localStorage.getItem("currentTopology"));
    // var rootGridElementIdValue = JSON.parse(localStorage.getItem("root"));

    // var sccInput: SCCInput;
    // sccInput.voltageAtRoot = parseInt((<HTMLInputElement>document.getElementById("voltageAtRootInput")).value);
    // sccInput.topologyId = JSON.parse(localStorage.getItem("currentTopology"));
    // sccInput.rootGridScenarioId = JSON.parse(localStorage.getItem("root"));
    // sccInput.planningScenarioIs = this.selectedScenarioId;
    const sccInput: SCCInput = this.getSCCInput();

    if(this.editPlanningScenarioMode){
      // console.log("Selected csenario id : >>> ", this.selectedScenarioId ,"THE VOLTGE FROM THE ROOOT >>> ", voltageAtRootValue, " some values of the scc : >> ", topologyIdValue.topologyId, "GRID ELEMENT ROOT ID : >> " , rootGridElementIdValue.gridElementId );
      this.runSCCAnalysis(sccInput)
    }else{
      this.runSCCAnalysis(sccInput);
    }
    this.activeModal.dismiss('SCCCStarted');
  }

  getSCCInput(){
    const sccInput: SCCInput = new SCCInput();
    sccInput.voltageAtRoot = parseInt((<HTMLInputElement>document.getElementById("voltageAtRootInput")).value);
    sccInput.topologyId = (JSON.parse(localStorage.getItem("currentTopology"))).topologyId;
    sccInput.rootGridElementId = (JSON.parse(localStorage.getItem("root"))).gridElementId;
    sccInput.coefficientMin = parseFloat((<HTMLInputElement>document.getElementById("coefficientMin")).value);
    sccInput.coefficientMax = parseFloat((<HTMLInputElement>document.getElementById("coefficientMax")).value);
    if(this.editPlanningScenarioMode){
      sccInput.planningScenarioId = this.selectedScenarioId;
    }
    return sccInput;
  }

  runSCCAnalysis(sccInput: SCCInput){
    console.log(sccInput);
    return this.httpClient.post("/icg/v1/rest/gui/runSCC", sccInput, {observe: 'response'}).pipe(catchError((error: HttpErrorResponse) => {
      // console.log("Error status > ", error.status);
      this.errorResponse = true;

      this.modalService.openBasicAlert(this.failureHeadingLabel, this.failureTextLabel);
      this.shortCircuitCurrentAnalysisService.isSccaAvailable = true; //change to false after TESTING
      this.isScccRunning = false;   //change to FALSE after TESTING
      return throwError(error);
    })
    ).subscribe(response => {
      // console.log("reposense Sucesfully > ", response);
      this.modalService.openBasicAlert(this.successHeadingLabel, this.successTextLabel);
      this.errorResponse = false;
      this.shortCircuitCurrentAnalysisService.isSccaAvailable = true;
      this.isScccRunning = true;
    })
  }

  checkCoefficientsMin(){
    let minCoefficient = <HTMLInputElement>document.getElementById("coefficientMin");
    let maxCoefficient = <HTMLInputElement>document.getElementById("coefficientMax");
    if(parseFloat(minCoefficient.value) >= parseFloat(maxCoefficient.value)){
      maxCoefficient.value = (parseFloat(minCoefficient.value) + 0.1).toFixed(1);
    }else{
      return;
    }
  }

  checkCoefficientsMax(){
    let minCoefficient = <HTMLInputElement>document.getElementById("coefficientMin");
    let maxCoefficient = <HTMLInputElement>document.getElementById("coefficientMax");
    if(parseFloat(maxCoefficient.value) <= parseFloat(minCoefficient.value)){
      minCoefficient.value = (parseFloat(maxCoefficient.value) - 0.1).toFixed(1);
    }else{
      return;
    }
  }
}
